import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { IUsuarioAdmin } from 'src/app/pages/usuarios-admin/data/usuario-admin';
import { EOrdenacao } from 'src/app/shared/data/ordenacao.enum';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';

@Component({
  selector: 'app-tab-usuarios-admin',
  templateUrl: './tab-usuarios-admin.component.html',
  styleUrls: ['./tab-usuarios-admin.component.scss']
})
export class TabUsuariosAdminComponent {
  ERoleAdminString = ERoleAdminString;
  @Input() dadosPaginacaoUsuariosAdmin = {
    ordenacao: EOrdenacao.AlfabeticaAZ,
    paginaSelecionada: 0,
    tamanhoPagina: 4,
    totalPaginas: 0,
    itensTotal: 0
  };
  @Input() usuariosAdmin: IUsuarioAdmin[] = [];
  @Input() companyId?: string;

  @Output() mudouPagina = new EventEmitter();
  @Output() mudouTamanhoPagina = new EventEmitter();
  @Output() recarregarListagem = new EventEmitter();

  constructor(private readonly router: Router) { }

  public abrirEmNovaAba(usuarioAdminId: string): void {
    const url = this.router.serializeUrl(this.router.createUrlTree([`/dash/usuarios-admin/editar/${usuarioAdminId}`]));

    window.open(url, '_blank');
  }
}
